import React from 'react';
import { Container } from '../../components/ui/Container';
export function ArabicChildSafeguardingPolicy() {
  return <section className="py-16 text-right md:py-24" dir="rtl" data-id="element-3600" data-mp="29omwlfi77a5n">
      <Container data-id="element-3601" data-mp="2ngjl79knr1xa">
        <article className="mx-auto max-w-4xl" data-id="element-3602" data-mp="2nh2tdykiaby4">
          <h1 className="font-display text-4xl font-semibold leading-[1.5] text-ink-900 md:text-6xl" data-id="element-3603" data-mp="2nixcr8g4pw03">
            سياسة حماية الطفل
          </h1>
          <p className="mt-4 text-ink-500" data-id="element-3604" data-mp="1urdrlizz27vg">
            <strong data-id="element-3605" data-mp="1uu8ah63c7kmr">آخر تحديث:</strong> 1 فبراير 2026
          </p>

          <div className="mt-10 space-y-8 leading-loose text-ink-700" data-id="element-3606" data-mp="1qrlnbihm2nvw">
            <p data-id="element-3607" data-mp="24qutrqg0m3mo">
              يلتزم <strong data-id="element-3608" data-mp="24rcxf850bk4m">المركز الدولي للتعلّم الإسلامي (IILH)</strong> التزامًا
              قاطعًا بحماية الأطفال وتعزيز رفاههم. وتبقى سلامة الأطفال وكرامتهم
              ورفاههم على رأس أولوياتنا.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3609" data-mp="3g3xaqmm10v7d">
              المعايير والأنشطة
            </h2>
            <p data-id="element-3610" data-mp="2f4ifth52db6u">
              تُنفَّذ جميع الأنشطة التي تشمل القاصرين، عبر الإنترنت أو خارجه، مع
              الالتزام الصارم بالمعايير الدولية لحماية الطفل.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3611" data-mp="2k4wqz81yp193">
              تدابير الحماية
            </h2>
            <p data-id="element-3612" data-mp="2tzyg43w8m3bo">نطبّق التدابير التالية لضمان بيئة آمنة:</p>
            <p data-id="element-3613" data-mp="1wdr9kogdi0wo">
              <strong data-id="element-3614" data-mp="1weagzb8ed6wg">• المحتوى:</strong> تقديم محتوى تعليمي مناسب لأعمار الأطفال.
            </p>
            <p data-id="element-3615" data-mp="21c2h2sj73zbq">
              <strong data-id="element-3616" data-mp="21dnecpww9wda">• الإشراف:</strong> الإشراف النشط والإدارة في جميع البيئات
              والمنتديات عبر الإنترنت.
            </p>
            <p data-id="element-3617" data-mp="269lwvwvjkk5s">
              <strong data-id="element-3618" data-mp="2b2f2emyu3wix">• الحدود:</strong> الحفاظ على حدود مهنية واضحة ومناسبة بين
              البالغين، من الموظفين والمعلّمين، والأطفال في جميع الأوقات.
            </p>
            <p data-id="element-3619" data-mp="1dmrfj8u0u0wj">
              <strong data-id="element-3620" data-mp="1dkx2egozrd30">• التدريب:</strong> تدريب إلزامي على حماية الطفل لجميع الموظفين
              والمعلّمين.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3621" data-mp="1al54ausszzdw">
              عدم التسامح مطلقًا
            </h2>
            <p data-id="element-3622" data-mp="15m1yv98wvr5e">
              تتبنى المنظمة <strong data-id="element-3623" data-mp="1kb82raip25jm">سياسة عدم التسامح مطلقًا</strong> مع إساءة معاملة
              الأطفال أو استغلالهم أو التحرّش بهم أو إهمالهم.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3624" data-mp="1fdg5s236zt8k">
              الإبلاغ عن المخاوف
            </h2>
            <p data-id="element-3625" data-mp="mnze56necgde">
              إذا كانت لديك أي مخاوف تتعلق بسلامة طفل أو بسلوك أحد أفراد الفريق، فيجب
              عليك الإبلاغ عنها فورًا.
            </p>
            <p data-id="element-3626" data-mp="11m1gjdioyvt2">
              <strong data-id="element-3627" data-mp="11idqwpgdatjm">التواصل:</strong>{' '}
              <a href="mailto:safeguarding@iilh.org" className="font-medium text-forest-700 underline underline-offset-2 transition hover:text-forest-800" dir="ltr" data-id="element-3628" data-mp="wkly7t7wf3ed">
                safeguarding@iilh.org
              </a>
            </p>
            <p data-id="element-3629" data-mp="2fja2mkp1zjvw">
              <strong data-id="element-3630" data-mp="2fiqkb2vhqthc">التعامل مع البلاغات:</strong> تُعامل جميع البلاغات بأقصى درجات
              السرية والجدية.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}